export const elements = {
  CONTACT: 'contact',
  LANGUAGES: 'languages',
  LOGIN: 'login',
  MENU: 'menu',
  SEARCH: 'search',
};

export const heights = {
  NAVIGATION_NARROW_HEIGHT: 50,
  NAVIGATION_LARGE_HEIGHT: 60,
};

export const NAVIGATION_OFFSET_SELECTOR = 'Navigation-bar';

export const NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT = '80vh';

export const ROOT_ID = 'rootSideNav';
